export default __webpack_public_path__ + "static/media/spark_49.8c3fdf22.png";